const generateEndPoint = (endpoint, query) => {
  return `${endpoint}${
    query
      ? `?${Object.entries(query)
          .map(([key, value]) =>
            Array.isArray(value)
              ? value.map((val) => `${key}=${val}`).join("&")
              : `${key}=${value}`
          )
          .join("&")}`
      : ""
  }`;
};
export default generateEndPoint;
